import { Stack, useRouter } from 'expo-router';
import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import { formatISO } from 'date-fns';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { PageHeader } from '~/layout/components/page-header/PageHeader';
import { LogMealHeader } from '~/meal/components/log-meal-header/LogMealHeader';
import { useCurrentOverviewDate } from '~/calendar/hooks/useCurrentOverviewDate';
import { Icon } from '~/global/components/icon/Icon';
import { MealLogSidebar } from '~/meal/components/meal-log-sidebar/MealLogSidebar';

export default function MealDetailLayout() {
  const { t } = useTranslation('meal');
  const router = useRouter();
  const currentDate = useCurrentOverviewDate();

  const handleClose = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace('/(overview)');
    }
  };

  const handleDateChange = (date: Date) => {
    router.replace(`/meals/${formatISO(date, { representation: 'date' })}`);
  };

  return (
    <FullHeightWrapper>
      <MealLogSidebar />
      <LogMealHeader
        currentDate={currentDate}
        onDateChange={handleDateChange}
      />
      <PageHeader
        className="md:hidden"
        title={t('logMeal')}
        actions={
          <Pressable
            onPress={handleClose}
            accessibilityRole="button"
            className="h-8 w-8 items-center justify-center rounded-full bg-surface-elevated active:opacity-70"
          >
            <Icon name="X" size={18} className="text-text-muted" />
          </Pressable>
        }
      />
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="[date]" />
      </Stack>
    </FullHeightWrapper>
  );
}
